import { useMemo } from "react";

import { useTypedSelector } from "../redux/store";
import useCurrentTaxiServices from "./useCurrentTaxiService";

/**
 *
 * @param taxiServiceId - Optional taxi service ID. Made for map context fix.
 * @returns {string} - Returns map name for the specified or default taxi service.
 */
const useTaxiServiceSettings = (taxiServiceId?: number): Record<string, any> | undefined => {
	const taxiServices = useTypedSelector((state) => state.taxiServices.models);
	const defaultTaxiService = useCurrentTaxiServices();
	const taxiServiceName = useMemo(() => {
		if (taxiServiceId) {
			const taxiService = taxiServices.find(
				(ts) => ts.id === taxiServiceId,
			);
			return taxiService?.settings;
		}
		return defaultTaxiService?.settings;
	}, [taxiServiceId, taxiServices, defaultTaxiService]);

	return taxiServiceName;
};

export default useTaxiServiceSettings;
